import React from 'react';
import { Provider } from 'react-redux';
import { MixpanelProvider } from 'react-mixpanel-browser';
import configureStore from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import '@fontsource/assistant';
import './stylesheets/css/cymbio-ic/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheets/scss/custom-media-grid.scss';
import './stylesheets/scss/retailers-media-grid.scss';
import './stylesheets/scss/media-grid-products.scss';
import './stylesheets/scss/brands-replenish-media-grid.scss';
import './stylesheets/css/scrollbar.css';
import './stylesheets/css/fonts.css';
import 'react-tagsinput/react-tagsinput.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-phone-number-input/style.css';
import './stylesheets/scss/App.scss';
import LocalGTMProvider from './containers/common/LocalGTMProvider';
import IsMobile from './containers/common/IsMobile';
import { CymbioSpinner } from './components/common/Spinner';
import { FlagsmithProvider } from 'flagsmith-react';
import useCookie from './hooks/useCookie';
import { CYMBIO_AUTOMATION_COOKIE } from './constants/mainConstants';
import IdentifyFlagsmith from './containers/common/IdentifyFlagsmith';
import { AppLoader } from './containers/common/AppLoader';

const FLAGSMITH_EDGE_API = 'https://edge.api.flagsmith.com/api/v1/';

export default function App() {
  const { store, persistor } = configureStore();
  const { hasCookie } = useCookie();
  const flagsmith = process.env.REACT_APP_FLAGSMITH_API_TOKEN || '';

  return (
    <LocalGTMProvider>
      <Provider store={store}>
        <MixpanelProvider>
          <FlagsmithProvider
            environmentId={flagsmith}
            preventFetch={hasCookie(CYMBIO_AUTOMATION_COOKIE)}
            api={FLAGSMITH_EDGE_API}
          >
            <IdentifyFlagsmith>
              <PersistGate loading={<CymbioSpinner shouldCenterVerticallyInViewport />} persistor={persistor}>
                <IsMobile
                  desktop={<AppLoader />}
                  mobile={
                    <div id="mainContainer" className="not-supported">
                      <h2>Mobile is not supported</h2>
                      <h3>Please use a bigger screen</h3>
                    </div>
                  }
                />
              </PersistGate>
            </IdentifyFlagsmith>
          </FlagsmithProvider>
        </MixpanelProvider>
      </Provider>
    </LocalGTMProvider>
  );
}
